import { useOutletContext } from 'react-router-dom';

import { FINANCIAL_DOCUMENT_STATUS } from 'src/features/financialDocuments/utils/types';
import { CURRENCY } from 'src/types';

/**
 * Values the financial document dashboard hands to its tab routes.
 *
 * Only the fields the tabs consume are passed rather than the whole document, so the coupling
 * between the dashboard and its tabs stays narrow.
 */
export type FinancialDocumentTabContext = {
    documentStatus?: FINANCIAL_DOCUMENT_STATUS;
    currency?: CURRENCY;
    disableAllocationCreate: boolean;
};

export const useFinancialDocumentTabContext = (): FinancialDocumentTabContext =>
    useOutletContext<FinancialDocumentTabContext>();
